import ExcelJS from "exceljs";
import moment from "moment";
import { saveAs } from "file-saver";
import { formatCurrency, getAlert, getData, getDataWithJoin, parseCurrency } from "./SamuiUtils";
import { formatDate, formatDateAndTime } from "./DateUtils";

export async function ExportInventories(data) {
    if (!Array.isArray(data) || data.length === 0) {
        return getAlert("FAILED", "ไม่มีข้อมูลสินค้าคงเหลือ");
    }

    try {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("สินค้าคงเหลือ");

        // เพิ่ม Header พร้อมกำหนดสไตล์
        worksheet.columns = [
            { header: "รหัสสินค้า", key: "Item_Code", width: 15 },
            { header: "ชื่อสินค้า", key: "Item_Name", width: 30 },
            { header: "คงเหลือ", key: "Item_Onhand", width: 15 },
            { header: "คลังสินค้า", key: "WH_Name", width: 20 },
            { header: "รายการล่าสุด", key: "Last_STC_Date", width: 25 },
        ];

        worksheet.getRow(1).eachCell((cell) => {
            cell.font = { bold: true, color: { argb: "FFFF0000" } }; // ตัวหนังสือสีแดง
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFFFFF00" }, // สีเหลือง
            };
            cell.alignment = { vertical: "middle", horizontal: "center" }; // จัดตำแหน่งกลาง
        });

        // เพิ่มข้อมูล
        data.forEach((item) => {
            worksheet.addRow({
                Item_Code: item.Item_Code,
                Item_Name: item.Item_Name,
                Item_Onhand: formatCurrency(item.Item_Onhand),
                WH_Name: item.WH_Name,
                Last_STC_Date: formatDateAndTime(item.Last_STC_Date),
            });
        });

        // บันทึกไฟล์
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), "สินค้าคงเหลือ.xlsx");
    } catch (error) {
        console.error("Error exporting inventories:", error);
        getAlert("FAILED", "ไม่สามารถ Export ข้อมูลได้");
    }
}

export async function ExportInventoriesWarehouse(data) {
    if (!Array.isArray(data) || data.length === 0) {
        return getAlert("FAILED", "ไม่มีข้อมูลสินค้าคงเหลือแยกตามคลัง");
    }

    try {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("สินค้าคงเหลือแยกตามคลัง");

        // เพิ่ม Header พร้อมกำหนดสไตล์
        worksheet.columns = [
            { header: "รหัสสินค้า", key: "Item_Code", width: 15 },
            { header: "ชื่อสินค้า", key: "Item_Name", width: 30 },
            { header: "คงเหลือ", key: "Item_Onhand", width: 15 },
            { header: "คลังสินค้า", key: "WH_Name", width: 20 },
            { header: "รายการล่าสุด", key: "Last_STC_Date", width: 25 },
        ];

        worksheet.getRow(1).eachCell((cell) => {
            cell.font = { bold: true, color: { argb: "FFFF0000" } }; // ตัวหนังสือสีแดง
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFFFFF00" }, // สีเหลือง
            };
            cell.alignment = { vertical: "middle", horizontal: "center" }; // จัดตำแหน่งกลาง
        });

        // เพิ่มข้อมูล
        data.forEach((item) => {
            worksheet.addRow({
                Item_Code: item.Item_Code,
                Item_Name: item.Item_Name,
                Item_Onhand: formatCurrency(item.Item_Onhand),
                WH_Name: item.WH_Name,
                Last_STC_Date: formatDateAndTime(item.Last_STC_Date),
            });
        });

        // บันทึกไฟล์
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), "สินค้าคงเหลือแยกตามคลัง.xlsx");
    } catch (error) {
        console.error("Error exporting inventories:", error);
        getAlert("FAILED", "ไม่สามารถ Export ข้อมูลได้");
    }
}

export async function ExportHistoryStock(data, year, month) {
    if (!Array.isArray(data) || data.length === 0) {
        return getAlert("FAILED", "ไม่มีข้อมูลสินค้าเคลื่อนไหว");
    }

    try {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("สินค้าเคลื่อนไหว_" + month + "-" + year);

        // ตั้งค่าคอลัมน์
        worksheet.columns = [
            { header: "#", key: "index", width: 5 },
            { header: "รหัสสินค้า", key: "Item_Code", width: 15 },
            { header: "ชื่อสินค้า", key: "Item_Name", width: 25 },
            { header: "ประเภท", key: "Doc_Type", width: 10 },
            { header: "จำนวน", key: "STC_QTY", width: 10 },
            { header: "จำนวนคงเหลือ", key: "STC_Balance", width: 15 },
            { header: "วันที่ทำรายการ", key: "STC_Date", width: 20 },
            { header: "คลังสินค้า", key: "WH_Name", width: 25 },
            { header: "เลขเอกสาร", key: "Doc_No", width: 20 },
            { header: "เอกสารอ้างอิง", key: "Doc_NoRef", width: 20 },
            { header: "หมายเหตุ", key: "STC_Remark", width: 20 },
        ];

        worksheet.getRow(1).eachCell((cell) => {
            cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFEF6C00" },
            };
            cell.alignment = { vertical: "middle", horizontal: "center" };
        });

        // เพิ่มข้อมูล
        data.forEach((item, index) => {
            worksheet.addRow({
                index: index + 1,
                Item_Code: item.Item_Code,
                Item_Name: item.Item_Name,
                Doc_Type: item.Doc_Type,
                STC_QTY: formatCurrency(item.STC_QTY),
                STC_Balance: formatCurrency(item.STC_Balance),
                STC_Date: formatDateAndTime(item.STC_Date),
                WH_Name: item.WH_Name,
                Doc_No: item.Doc_No,
                Doc_NoRef: item.Doc_NoRef,
                STC_Remark: item.STC_Remark || '-',
            });
        });

        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), "สินค้าเคลื่อนไหว_" + month + "-" + year + ".xlsx");
    } catch (error) {
        console.error("Error exporting stock history:", error);
        getAlert("FAILED", "ไม่สามารถ Export ข้อมูลได้");
    }
}

export async function ExportVansaleSalesReport(docId, docNo) {
    if (!docId) {
        return getAlert("FAILED", "ไม่พบเลขเอกสารของ Picking List");
    }

    try {
        const fetchDataPkList = await getData(
            'API_0801_PKList_H',
            `Doc_Id = ${docId}`);
        const fetchDataWhDocH = await getDataWithJoin(
            ' WD_D.Item_Id, WD_D.Item_Name, SUM(WD_D.Item_Qty) AS Item_Qty ',
            ' API_1001_WHDOC_H WD_H ',
            ' LEFT JOIN API_1002_WHDOC_D WD_D ON (WD_H.WHDoc_Id = WD_D.WHDoc_Id) ',
            ` WHERE (WHDoc_Type = 3) AND (Picking_No = '${docNo}') GROUP BY WD_D.Item_Id,WD_D.Item_Name ORDER BY WD_D.Item_Id `
        );
        const fetchDataSoHForItem = await getDataWithJoin(
            ' SO_D.Item_Id, SO_D.Item_Name, SUM(SO_D.Item_Qty) AS Item_Qty ',
            ' API_0701_SO_H SO_H ',
            ' LEFT JOIN API_0702_SO_D SO_D ON (SO_H.Doc_ID = SO_D.Doc_ID) ',
            ` WHERE SO_H.Doc_Is_PickingList = ${docId} GROUP BY SO_D.Item_Id,SO_D.Item_Name ORDER BY SO_D.Item_Id`
        );
        const fetchDataSoHForPayTotal = await getDataWithJoin(
            ' SO_H.Doc_Status_Paid_Type, SUM(SO_H.Pay_Total) AS Pay_Total ',
            ' API_0701_SO_H SO_H ',
            ` WHERE SO_H.Doc_Is_PickingList = ${docId} `,
            ' GROUP BY SO_H.Doc_Status_Paid_Type '
        );
        const fetchDataPkListForPaymentType = await getDataWithJoin(
            `PK_H.Doc_Id, PK_H.Doc_No AS Pk_No, SO_H.Doc_No AS So_No, PK_D.AR_Id, PK_D.DL_Queue AS AR_Queue, PK_D.AR_Name, SO_H.Total_Before_Vat, SO_H.VAT, 
            SO_H.NetTotal, SO_H.Pay_Total, SO_H.Doc_Status_Paid_Type, 
            CASE
                WHEN SO_H.Doc_Status_Paid_Type = 1 THEN 'เงินสด'
                WHEN SO_H.Doc_Status_Paid_Type = 2 THEN 'โอน'
                WHEN SO_H.Doc_Status_Paid_Type = 3 THEN 'เช็ค'
                WHEN SO_H.Doc_Status_Paid_Type = 4 THEN 'เครดิต'
                WHEN SO_H.Doc_Status_Paid_Type = 5 THEN 'ค้างจ่าย'
                ELSE 'ไม่ระบุ'
            END AS PaymentType, 
            PK_H.Driver1, AR.Default_Price, AR.AR_SPrice_id, AR.AR_SPrice_use, PA_O.Item_Onhand`,
            `API_0801_PKList_H AS PK_H`,
            `LEFT JOIN API_0802_PKList_D AS PK_D ON (PK_H.Doc_Id = PK_D.Doc_Id)
            LEFT JOIN API_0701_SO_H AS SO_H ON (PK_H.Doc_Id = SO_H.Doc_Is_PickingList AND SO_H.AR_Id = PK_D.AR_Id)
            LEFT JOIN Tb_Set_AR AS AR ON (AR.AR_Id = PK_D.AR_Id)
            LEFT JOIN WH_ARPAYMENT_Onhand AS PA_O ON (AR.AR_Id = PA_O.Item_Id)`,
            `WHERE PK_H.Doc_Id = ${docId} ORDER BY PK_D.DL_Queue ASC`
        );
        const fetchDataPkListDetailForWhDocH = await getDataWithJoin(
            `PK_D.AR_Id, WD_H.WHDoc_Id, WD_D.Item_Code`,
            `API_0802_PKList_D AS PK_D`,
            `LEFT JOIN API_1001_WHDOC_H AS WD_H ON (PK_D.AR_Id = WD_H.T_WH_Id)
            LEFT JOIN API_1002_WHDOC_D AS WD_D ON (WD_H.WHDoc_Id = WD_D.WHDoc_Id)`,
            `WHERE WD_H.WHDoc_Type = 5`
        );

        const fetchDataCloseMoeny = await getDataWithJoin(
            `(B1000 * 1000 +
                B500 * 500 +
                B100 * 100 +
                B50 * 50 +
                B20 * 20 +
                B10 * 10 +
                B5 * 5 +
                B2 * 2 +
                B1 * 1) AS Total_Sent_Amount,
                Lost_Money AS Difference_Amount
            `,
            `PKList_CloseMoney`,
            ``,
            `WHERE PKList_Id = ${docId}`
        );

        const fetchDataCloseStock = await getData(
            'PKList_CloseStock',
            `PKList_ID = ${docId}`
        );

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("รายงานขาย Vansale");

        worksheet.getCell("A1").value = "สายส่ง";
        worksheet.getCell("A1").font = { bold: true };
        worksheet.mergeCells("B1:C1");
        worksheet.getCell("B1").value = fetchDataPkList[0].DL_LineName;
        worksheet.getCell("D1").value = "รอบ";

        switch (parseCurrency(fetchDataPkList[0].PK_Round)) {
            case 1:
                worksheet.getCell("E1").value = "รอบเช้า";
                break;
            case 2:
                worksheet.getCell("E1").value = "รอบบ่าย";
                break;
            case 3:
                worksheet.getCell("E1").value = "รอบเย็น";
                break;
            default:
                worksheet.getCell("E1").value = "ไม่พบรอบ";
                break;
        }

        worksheet.getCell("B2").value = "น้ำแข็งเบิก";
        worksheet.getCell("B2").font = { bold: true };
        worksheet.getCell("C2").value = "น้ำแข็งขาย";
        worksheet.getCell("C2").font = { bold: true };
        worksheet.getCell("D2").value = "น้ำแข็งเหลือ";
        worksheet.getCell("D2").font = { bold: true };
        worksheet.getCell("E2").value = "น้ำแข็งคืน";
        worksheet.getCell("E2").font = { bold: true };
        worksheet.getCell("F2").value = "น้ำแข็งหาย";
        worksheet.getCell("F2").font = { bold: true };

        worksheet.getCell("A3").value = "หลอดใหญ่";
        worksheet.getCell("A3").font = { bold: true };
        worksheet.getCell("A4").value = "หลอดเล็ก";
        worksheet.getCell("A4").font = { bold: true };
        worksheet.getCell("A5").value = "บดใหญ่";
        worksheet.getCell("A5").font = { bold: true };
        worksheet.getCell("A6").value = "บดเล็ก";
        worksheet.getCell("A6").font = { bold: true };

        worksheet.getCell("B3").value = formatCurrency(0);
        worksheet.getCell("B4").value = formatCurrency(0);
        worksheet.getCell("B5").value = formatCurrency(0);
        worksheet.getCell("B6").value = formatCurrency(0);

        for (const data of fetchDataWhDocH) {
            if (data.Item_Name === "หลอดใหญ่") {
                worksheet.getCell("B3").value = formatCurrency(data.Item_Qty);
            } else if (data.Item_Name === "หลอดเล็ก") {
                worksheet.getCell("B4").value = formatCurrency(data.Item_Qty);
            } else if (data.Item_Name === "บดใหญ่") {
                worksheet.getCell("B5").value = formatCurrency(data.Item_Qty);
            } else if (data.Item_Name === "บดเล็ก") {
                worksheet.getCell("B6").value = formatCurrency(data.Item_Qty);
            }
        }

        worksheet.getCell("C3").value = formatCurrency(0);
        worksheet.getCell("C4").value = formatCurrency(0);
        worksheet.getCell("C5").value = formatCurrency(0);
        worksheet.getCell("C6").value = formatCurrency(0);

        for (const data of fetchDataSoHForItem) {
            if (data.Item_Name === "หลอดใหญ่") {
                worksheet.getCell("C3").value = formatCurrency(data.Item_Qty);
            } else if (data.Item_Name === "หลอดเล็ก") {
                worksheet.getCell("C4").value = formatCurrency(data.Item_Qty);
            } else if (data.Item_Name === "บดใหญ่") {
                worksheet.getCell("C5").value = formatCurrency(data.Item_Qty);
            } else if (data.Item_Name === "บดเล็ก") {
                worksheet.getCell("C6").value = formatCurrency(data.Item_Qty);
            }
        }

        // Store B3, B4, B5, B6, C3, C4, C5, C6 as numbers
        const B3 = parseCurrency(worksheet.getCell("B3").value);
        const B4 = parseCurrency(worksheet.getCell("B4").value);
        const B5 = parseCurrency(worksheet.getCell("B5").value);
        const B6 = parseCurrency(worksheet.getCell("B6").value);
        const C3 = parseCurrency(worksheet.getCell("C3").value);
        const C4 = parseCurrency(worksheet.getCell("C4").value);
        const C5 = parseCurrency(worksheet.getCell("C5").value);
        const C6 = parseCurrency(worksheet.getCell("C6").value);

        // Calculate D3-D6 = เบิก - ขาย
        const D3 = B3 - C3;
        const D4 = B4 - C4;
        const D5 = B5 - C5;
        const D6 = B6 - C6;
        worksheet.getCell("D3").value = formatCurrency(D3);
        worksheet.getCell("D4").value = formatCurrency(D4);
        worksheet.getCell("D5").value = formatCurrency(D5);
        worksheet.getCell("D6").value = formatCurrency(D6);

        // Fill น้ำแข็งคืน (E3-E6) from fetchDataCloseStock
        const closeStockMap = {
            1402: "E3",
            1403: "E4",
            1404: "E5",
            1405: "E6"
        };
        for (const [itemId, cellRef] of Object.entries(closeStockMap)) {
            const match = fetchDataCloseStock.find(item => parseCurrency(item.Item_Id) === parseCurrency(itemId));
            console.debug("match : ", match);
            worksheet.getCell(cellRef).value = formatCurrency(match?.Item_Return_Qty || 0);
        }

        // Store E3-E6 as numbers
        const E3 = parseCurrency(worksheet.getCell("E3").value);
        const E4 = parseCurrency(worksheet.getCell("E4").value);
        const E5 = parseCurrency(worksheet.getCell("E5").value);
        const E6 = parseCurrency(worksheet.getCell("E6").value);

        // Calculate F3-F6 = น้ำแข็งเหลือ - น้ำแข็งคืน
        worksheet.getCell("F3").value = formatCurrency(D3 - E3);
        worksheet.getCell("F4").value = formatCurrency(D4 - E4);
        worksheet.getCell("F5").value = formatCurrency(D5 - E5);
        worksheet.getCell("F6").value = formatCurrency(D6 - E6);

        worksheet.getCell("A8").value = "หมายเหตุ";
        worksheet.getCell("A8").font = { bold: true };
        worksheet.mergeCells("B8:H8");

        worksheet.getCell("J1").value = "วันที่เอกสาร";
        worksheet.getCell("J1").font = { bold: true };
        worksheet.getCell("K1").value = formatDate(fetchDataPkList[0].Doc_Date);

        worksheet.getCell("J2").value = "ช่องทางชำระเงิน";
        worksheet.getCell("J2").font = { bold: true };
        worksheet.getCell("K2").value = "ยอดเงิน";
        worksheet.getCell("K2").font = { bold: true };
        worksheet.getCell("J3").value = "เงินสด";
        worksheet.getCell("J3").font = { bold: true };
        worksheet.getCell("J4").value = "โอน";
        worksheet.getCell("J4").font = { bold: true };
        worksheet.getCell("J5").value = "เครดิต";
        worksheet.getCell("J5").font = { bold: true };
        worksheet.getCell("J6").value = "เช็ค";
        worksheet.getCell("J6").font = { bold: true };
        worksheet.getCell("J7").value = "ค้างจ่าย";
        worksheet.getCell("J7").font = { bold: true };
        worksheet.getCell("J8").value = "รวม";
        worksheet.getCell("J8").font = { bold: true };

        worksheet.getCell("J9").value = "จำนวนเงินที่ส่ง";
        worksheet.getCell("J9").font = { bold: true };
        worksheet.getCell("J10").value = "เงินขาด/เงินเกิน";
        worksheet.getCell("J10").font = { bold: true };

        worksheet.getCell("K3").value = formatCurrency(0);
        worksheet.getCell("K4").value = formatCurrency(0);
        worksheet.getCell("K5").value = formatCurrency(0);
        worksheet.getCell("K6").value = formatCurrency(0);
        worksheet.getCell("K7").value = formatCurrency(0);

        let total = 0;

        for (const data of fetchDataSoHForPayTotal) {
            if (data.Doc_Status_Paid_Type === 1) {
                worksheet.getCell("K3").value = formatCurrency(data.Pay_Total);
            } else if (data.Doc_Status_Paid_Type === 2) {
                worksheet.getCell("K4").value = formatCurrency(data.Pay_Total);
            } else if (data.Doc_Status_Paid_Type === 3) {
                worksheet.getCell("K5").value = formatCurrency(data.Pay_Total);
            } else if (data.Doc_Status_Paid_Type === 4) {
                worksheet.getCell("K6").value = formatCurrency(data.Pay_Total);
            } else if (data.Doc_Status_Paid_Type === 5) {
                worksheet.getCell("K7").value = formatCurrency(data.Pay_Total);
            }

            total += data.Pay_Total;
        }

        worksheet.getCell("K8").value = formatCurrency(total);

        worksheet.getCell("K9").value = formatCurrency(fetchDataCloseMoeny[0]?.Total_Sent_Amount || 0);
        worksheet.getCell("K10").value = formatCurrency(fetchDataCloseMoeny[0]?.Difference_Amount || 0);

        // ตั้งค่าหัวตารางหลัก
        const headers = [
            "ยอดรวมหลอดใหญ่", "ยอดรวมหลอดเล็ก", "ยอดรวมบดใหญ่", "ยอดรวมบดเล็ก", "คิว",
            "รายชื่อลูกค้า", "เลขลัง", "ราคา", "ยอดรวมยกมา", "ยอดรวมจ่าย", "ยอดรวมค้างจ่าย"
        ];

        // เว้นช่วงระหว่าง 4 แถว
        worksheet.addRow([]);
        worksheet.addRow([]);
        worksheet.addRow([]);
        worksheet.addRow([]);

        const headerRow = worksheet.addRow(headers);

        // กำหนดสไตล์ให้กับ Header
        headerRow.eachCell((cell, colNumber) => {
            cell.font = { bold: true, color: { argb: "FF000000" } }; // สีดำ
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFFFFFFF" } // พื้นหลังสีขาว
            };
            cell.alignment = { vertical: "middle", horizontal: "center" };
        });

        // วนลูปดึงข้อมูลการขายจาก `fetchDataPkListForPaymentType`
        for (const data of fetchDataPkListForPaymentType) {
            // ดึงข้อมูลขายของลูกค้าคนนี้
            const fetchDataPkListDetailForSell = await getDataWithJoin(
                ` SO_D.Item_Id, SO_D.Item_Name, SUM(SO_D.Item_Qty) AS Item_Qty `,
                ` API_0802_PKList_D AS PK_D `,
                ` LEFT JOIN API_0701_SO_H AS SO_H ON (PK_D.SO_Id = SO_H.Doc_ID) 
            LEFT JOIN API_0702_SO_D AS SO_D ON (SO_H.Doc_ID = SO_D.Doc_ID) `,
                ` WHERE SO_H.Doc_No = '${data.So_No}' 
            GROUP BY SO_D.Item_Id, SO_D.Item_Name 
            ORDER BY SO_D.Item_Id`
            );

            // กำหนดค่าเริ่มต้นเป็น 0
            let หลอดใหญ่ = 0, หลอดเล็ก = 0, บดใหญ่ = 0, บดเล็ก = 0;

            // วนลูปดึงค่าตามประเภทน้ำแข็ง
            for (const item of fetchDataPkListDetailForSell) {
                if (item.Item_Name === "หลอดใหญ่") {
                    หลอดใหญ่ = formatCurrency(item.Item_Qty);
                } else if (item.Item_Name === "หลอดเล็ก") {
                    หลอดเล็ก = formatCurrency(item.Item_Qty);
                } else if (item.Item_Name === "บดใหญ่") {
                    บดใหญ่ = formatCurrency(item.Item_Qty);
                } else if (item.Item_Name === "บดเล็ก") {
                    บดเล็ก = formatCurrency(item.Item_Qty);
                }
            }

            // กำหนดค่าอื่นๆ
            let คิว = data.AR_Queue;
            let รายชื่อลูกค้า = data.AR_Name;
            let เลขลัง = (data.AR_Id === fetchDataPkListDetailForWhDocH.AR_Id) ? fetchDataPkListDetailForWhDocH.Item_Code : '';
            let ราคา = formatCurrency(data.NetTotal);
            let ยกมา = '';
            let จ่าย = formatCurrency(data.Pay_Total);
            let ค้างจ่าย = formatCurrency(data.Item_Onhand);

            // เพิ่มแถวข้อมูลเข้า Excel
            worksheet.addRow([
                หลอดใหญ่, หลอดเล็ก, บดใหญ่, บดเล็ก, คิว,
                รายชื่อลูกค้า, เลขลัง, ราคา, ยกมา, จ่าย, ค้างจ่าย
            ]);
        }

        // เพิ่มเส้นขอบให้ทุกเซลล์ในทุกแถว (ทั้ง Header และข้อมูล)
        worksheet.eachRow((row) => {
            row.eachCell((cell) => {
                cell.border = {
                    top: { style: "thin", color: { argb: "FF000000" } },
                    left: { style: "thin", color: { argb: "FF000000" } },
                    bottom: { style: "thin", color: { argb: "FF000000" } },
                    right: { style: "thin", color: { argb: "FF000000" } }
                };
            });
        });

        // บันทึกไฟล์
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), "รายงานขาย_Vansale.xlsx");
    } catch (error) {
        getAlert("FAILED", "ไม่สามารถ Export ข้อมูลได้");
    }
}

export async function ExportPaymentStockReport(data) {
    if (!Array.isArray(data) || data.length === 0) {
        return getAlert("FAILED", "ไม่มีข้อมูลลูกค้าค้างจ่าย");
    }

    try {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("ลูกค้าค้างจ่าย");

        worksheet.columns = [
            { header: "รหัสลูกค้า", key: "AR_Code", width: 15 },
            { header: "ชื่อลูกค้า", key: "AR_Name", width: 30 },
            { header: "คงเหลือ", key: "Item_Onhand", width: 15 },
        ];

        worksheet.getRow(1).eachCell((cell) => {
            cell.font = { bold: true, color: { argb: "FFFF0000" } };
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFFFFF00" },
            };
            cell.alignment = { vertical: "middle", horizontal: "center" };
            cell.border = {
                top: { style: "thin", color: { argb: "FF000000" } },
                left: { style: "thin", color: { argb: "FF000000" } },
                bottom: { style: "thin", color: { argb: "FF000000" } },
                right: { style: "thin", color: { argb: "FF000000" } },
            };
        });

        let totalAmount = 0; // ตัวแปรสำหรับคำนวณยอดรวม

        data.forEach((item) => {
            const row = worksheet.addRow({
                AR_Code: item.AR_Code,
                AR_Name: item.AR_Name,
                Item_Onhand: formatCurrency(item.Item_Onhand),
            });
            totalAmount += item.Item_Onhand; // คำนวณยอดรวม

            row.eachCell((cell) => {
                cell.border = {
                    top: { style: "thin", color: { argb: "FF000000" } },
                    left: { style: "thin", color: { argb: "FF000000" } },
                    bottom: { style: "thin", color: { argb: "FF000000" } },
                    right: { style: "thin", color: { argb: "FF000000" } },
                };
            });
        });

        // คำนวณข้อความสำหรับ Footer
        let footerMessage = "";
        if (totalAmount < 0) {
            footerMessage = `ค้างจ่าย ${formatCurrency(totalAmount)} บาท`;
        } else if (totalAmount > 0) {
            footerMessage = `จ่ายเกิน ${formatCurrency(totalAmount)} บาท`;
        } else {
            footerMessage = `ไม่ค้างจ่าย 0.00 บาท`;
        }

        // เพิ่มแถว Footer
        worksheet.addRow([]);

        // Merge columns B and C for the footer and put the message in column C
        worksheet.mergeCells(`B${worksheet.lastRow.number}:C${worksheet.lastRow.number}`);
        const footerCell = worksheet.getCell(`B${worksheet.lastRow.number}`);
        footerCell.value = footerMessage; // Put the footerMessage in the merged cell

        // Apply styling to the footer cell
        footerCell.alignment = { horizontal: "right", vertical: "center" };
        footerCell.font = { color: { argb: "FF0000" }, bold: true };
        footerCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFFF00" },
        };

        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), "ลูกค้าค้างจ่าย.xlsx");
    } catch (error) {
        console.error("Error exporting filtered AR list:", error);
        getAlert("FAILED", "ไม่สามารถ Export ข้อมูลได้");
    }
}

export async function ExportPo(data) {
    if (!Array.isArray(data) || data.length === 0) {
        return getAlert("FAILED", "ไม่มีข้อมูลใบสั่งซื้อ");
    }

    try {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("ใบสั่งซื้อ");

        // ตั้งค่าหัวตาราง (ตามตัวอย่าง JSON)
        worksheet.columns = [
            { header: "เลขที่เอกสาร", key: "docNo", width: 15 },
            { header: "ประเภท", key: "type", width: 20 },
            { header: "สถานะเอกสาร", key: "status", width: 15 },
            { header: "สถานะรับสินค้า", key: "receiveStatus", width: 20 },
            { header: "สถานะชำระเงิน", key: "paymentStatus", width: 15 },
            { header: "วันที่เอกสาร", key: "docDate", width: 20 },
            { header: "วันที่จัดส่ง", key: "deliveryDate", width: 20 },
            { header: "รหัสเจ้าหนี้", key: "vendorCode", width: 20 },
            { header: "ชื่อเจ้าหนี้", key: "vendorName", width: 30 },
            { header: "ยอดรวม", key: "total", width: 15 },
            { header: "สร้างรายการโดย", key: "createdBy", width: 25 },
            { header: "รายละเอียดเอกสาร", key: "remark1", width: 30 },
            { header: "หมายเหตุธุรการ", key: "remark2", width: 30 },
        ];

        worksheet.getRow(1).eachCell((cell) => {
            cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFEF6C00" },
            };
            cell.alignment = { vertical: "middle", horizontal: "center" };
        });

        // เพิ่มข้อมูลจาก JSON (mapping ตามตัวอย่าง JSON)
        data.forEach((item) => {
            worksheet.addRow({
                docNo: item.Doc_No,
                type: item.DocType_Name,
                status: item.DocStatus_Name,
                receiveStatus: item.Doc_Status_ReceiveName,
                paymentStatus: item.Doc_Status_PaidName,
                docDate: formatDate(item.Doc_Date),
                deliveryDate: formatDate(item.Doc_DueDate),
                vendorCode: item.AP_Code,
                vendorName: item.AP_Name,
                total: formatCurrency(item.NetTotal),
                createdBy: item.Created_By_Name,
                remark1: item.Doc_Remark1 || "",
                remark2: item.Doc_Remark2 || "",
            });
        });

        // ตั้งค่าเส้นขอบให้ทุกเซลล์
        worksheet.eachRow((row) => {
            row.eachCell((cell) => {
                cell.border = {
                    top: { style: "thin", color: { argb: "FF000000" } },
                    left: { style: "thin", color: { argb: "FF000000" } },
                    bottom: { style: "thin", color: { argb: "FF000000" } },
                    right: { style: "thin", color: { argb: "FF000000" } },
                };
            });
        });

        // บันทึกไฟล์
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), "ใบสั่งซื้อ.xlsx");
    } catch (error) {
        console.error("Error exporting purchase order:", error);
        getAlert("FAILED", "ไม่สามารถ Export ข้อมูลได้");
    }
}

export async function ExportSo(data) {
    if (!Array.isArray(data) || data.length === 0) {
        return getAlert("FAILED", "ไม่มีข้อมูลใบขาย");
    }

    try {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("ใบขาย");

        // ตั้งค่าหัวตารางตามคอลัมน์ในรูป
        worksheet.columns = [
            { header: "เลขที่เอกสาร", key: "docNo", width: 15 },
            { header: "เลขที่ใบวางบิล", key: "invoiceNo", width: 15 },
            { header: "เลขที่กำกับภาษี", key: "taxNo", width: 15 },
            { header: "สถานะจ่าย", key: "paymentStatus", width: 15 },
            { header: "ประเภทการจ่าย", key: "paymentType", width: 15 },
            { header: "วันที่เอกสาร", key: "docDate", width: 20 },
            { header: "Due Date", key: "dueDate", width: 20 },
            { header: "รหัสลูกค้า", key: "customerCode", width: 20 },
            { header: "ชื่อผู้รับสินค้า", key: "customerName", width: 30 },
            { header: "ยอดรวม", key: "total", width: 15 },
        ];

        worksheet.getRow(1).eachCell((cell) => {
            cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFEF6C00" },
            };
            cell.alignment = { vertical: "middle", horizontal: "center" };
        });

        // เพิ่มข้อมูลจาก JSON โดยแมปคีย์ตามที่ระบุ
        data.forEach((item) => {
            worksheet.addRow({
                docNo: item.Doc_No,
                invoiceNo: item.Doc_BL_No || "-",
                taxNo: item.Doc_INV_No || "-",
                paymentStatus: item.DocStatusPaid_Name || "ยกเลิก",
                paymentType: item.DocStatusPaid_Type_Name || "ยกเลิก",
                docDate: formatDate(item.Doc_Date),
                dueDate: formatDate(item.Doc_DueDate),
                customerCode: item.AR_Code,
                customerName: item.AR_Name,
                total: formatCurrency(item.NetTotal),
            });
        });

        // ตั้งค่าเส้นขอบให้ทุกเซลล์
        worksheet.eachRow((row) => {
            row.eachCell((cell) => {
                cell.border = {
                    top: { style: "thin", color: { argb: "FF000000" } },
                    left: { style: "thin", color: { argb: "FF000000" } },
                    bottom: { style: "thin", color: { argb: "FF000000" } },
                    right: { style: "thin", color: { argb: "FF000000" } },
                };
            });
        });

        // บันทึกไฟล์
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), "ใบขาย.xlsx");
    } catch (error) {
        console.error("Error exporting sales order:", error);
        getAlert("FAILED", "ไม่สามารถ Export ข้อมูลได้");
    }
}

export async function ExportBillReportNew({
    rows = [],
    fromDate,
    toDate,
    company,
    fileNamePrefix = "รายงานใบวางบิล",
} = {}) {
    if (!Array.isArray(rows) || rows.length === 0) {
        return getAlert("FAILED", "ไม่มีข้อมูลสำหรับพิมพ์รายงาน");
    }

    try {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet(fileNamePrefix);

        const parseToMoment = (value) => {
            if (value === null || value === undefined || value === "") {
                return null;
            }

            if (moment.isMoment(value)) {
                return value.clone();
            }

            if (value instanceof Date) {
                const parsed = moment(value);
                return parsed.isValid() ? parsed : null;
            }

            if (typeof value === "number" && Number.isFinite(value)) {
                if (value > 1000000000) {
                    const timestampMoment = moment(value);
                    return timestampMoment.isValid() ? timestampMoment : null;
                }
                const excelEpoch = moment("1899-12-30", "YYYY-MM-DD");
                const excelMoment = excelEpoch.clone().add(value, "days");
                return excelMoment.isValid() ? excelMoment : null;
            }

            if (typeof value === "string") {
                const trimmed = value.trim();
                if (!trimmed) {
                    return null;
                }

                const isoParsed = moment(trimmed, moment.ISO_8601, true);
                if (isoParsed.isValid()) {
                    return isoParsed;
                }

                const candidateFormats = [
                    "YYYY-MM-DD HH:mm:ss",
                    "YYYY-MM-DDTHH:mm:ss",
                    "YYYY-MM-DD",
                    "YYYY/MM/DD",
                    "YYYYMMDD",
                    "DD/MM/YYYY",
                    "DD-MM-YYYY",
                    "MM/DD/YYYY",
                    "MM-DD-YYYY",
                ];

                for (const format of candidateFormats) {
                    const parsed = moment(trimmed, format, true);
                    if (parsed.isValid()) {
                        return parsed;
                    }
                }

                const fallback = moment(trimmed);
                return fallback.isValid() ? fallback : null;
            }

            return null;
        };

        const toThaiDate = (value, fallback = "-") => {
            const parsed = parseToMoment(value);
            if (!parsed) {
                return fallback;
            }
            const year = parsed.year() + 543;
            return `${parsed.format("DD/MM")}/${year}`;
        };

        const sanitizeAmount = (input) => {
            if (typeof input === "number" && !Number.isNaN(input)) {
                return Number(input.toFixed(2));
            }
            if (input == null || input === "") {
                return 0;
            }
            const parsed = parseCurrency(input);
            if (typeof parsed === "number" && !Number.isNaN(parsed)) {
                return Number(parsed.toFixed(2));
            }
            const numeric = Number(String(input).replace(/,/g, "").trim());
            return Number.isNaN(numeric) ? 0 : Number(numeric.toFixed(2));
        };

        const combineRemark = (item) => {
            const values = [];
            if (item?.Doc_Remark1) {
                values.push(String(item.Doc_Remark1).trim());
            }
            if (item?.Doc_Remark2) {
                values.push(String(item.Doc_Remark2).trim());
            }
            return values.filter((text) => text).join(" ") || "-";
        };

        const rowsSorted = [...rows].sort((a, b) => {
            const dateA = parseToMoment(a?.Doc_Date ?? a?.DocDate ?? a?.Doc_Date_Display);
            const dateB = parseToMoment(b?.Doc_Date ?? b?.DocDate ?? b?.Doc_Date_Display);
            if (dateA && dateB) {
                if (dateA.isSame(dateB)) {
                    return String(a?.Doc_No || "").localeCompare(String(b?.Doc_No || ""), "th", { numeric: true, sensitivity: "base" });
                }
                return dateA.valueOf() - dateB.valueOf();
            }
            if (dateA) return -1;
            if (dateB) return 1;
            return String(a?.Doc_No || "").localeCompare(String(b?.Doc_No || ""), "th", { numeric: true, sensitivity: "base" });
        });

        const fromMoment = (() => {
            const direct = parseToMoment(fromDate);
            if (direct) return direct;
            const fallback = parseToMoment(rowsSorted[0]?.Doc_Date ?? rowsSorted[0]?.DocDate ?? rowsSorted[0]?.Doc_Date_Display);
            return fallback ? fallback : null;
        })();

        const toMoment = (() => {
            const direct = parseToMoment(toDate);
            if (direct) return direct;
            const fallback = parseToMoment(rowsSorted[rowsSorted.length - 1]?.Doc_Date ?? rowsSorted[rowsSorted.length - 1]?.DocDate ?? rowsSorted[rowsSorted.length - 1]?.Doc_Date_Display);
            return fallback ? fallback : null;
        })();

        const firstRowCompany = rowsSorted.length > 0 ? {
            Comp_Name_TH: rowsSorted[0]?.Comp_Name_TH,
            Comp_Name_EN: rowsSorted[0]?.Comp_Name_EN,
            Comp_Add1: rowsSorted[0]?.Comp_Add1,
            Comp_Add2: rowsSorted[0]?.Comp_Add2,
            Comp_Add3: rowsSorted[0]?.Comp_Add3,
            Comp_Province: rowsSorted[0]?.Comp_Province,
            Comp_Post: rowsSorted[0]?.Comp_Post,
            Comp_Tel1: rowsSorted[0]?.Comp_Tel1,
            Comp_Tel2: rowsSorted[0]?.Comp_Tel2,
            Comp_TaxNo: rowsSorted[0]?.Comp_TaxNo,
        } : {};

        const resolvedCompany = {
            ...firstRowCompany,
            ...(company || {}),
        };

        const companyName = resolvedCompany?.Comp_Name_TH || resolvedCompany?.Comp_Name_EN || "บริษัท";

        const addressLines = [
            resolvedCompany?.Comp_Add1,
            resolvedCompany?.Comp_Add2,
            resolvedCompany?.Comp_Add3,
        ].filter((line) => line && line.trim() !== "");

        const provinceLineParts = [
            resolvedCompany?.Comp_Province,
            resolvedCompany?.Comp_Post,
        ].filter((part) => part && part.trim() !== "");
        if (provinceLineParts.length > 0) {
            addressLines.push(provinceLineParts.join(" "));
        }

        const contactLines = [];
        if (resolvedCompany?.Comp_TaxNo) {
            contactLines.push(`เลขประจำตัวผู้เสียภาษี ${resolvedCompany.Comp_TaxNo}`);
        }
        const phoneParts = [resolvedCompany?.Comp_Tel1, resolvedCompany?.Comp_Tel2].filter((tel) => tel && tel.trim() !== "");
        if (phoneParts.length > 0) {
            contactLines.push(`โทรศัพท์ ${phoneParts.join(" / ")}`);
        }

        const writtenBy = typeof window !== "undefined" ? (window.localStorage.getItem("name") || "-") : "-";

        let nextRowIndex = 1;
        const addFullWidthRow = (text, { font = {}, alignment = "left" } = {}) => {
            worksheet.mergeCells(`A${nextRowIndex}:F${nextRowIndex}`);
            const cell = worksheet.getCell(`A${nextRowIndex}`);
            cell.value = text || "";
            cell.font = { ...font };
            cell.alignment = { horizontal: alignment, vertical: "middle" };
            return nextRowIndex++;
        };

        addFullWidthRow(companyName, { font: { bold: true, size: 16 } });
        addressLines.forEach((line) => addFullWidthRow(line, { font: { size: 12 } }));
        contactLines.forEach((line) => addFullWidthRow(line, { font: { size: 12 } }));
        addFullWidthRow("");

        addFullWidthRow("ใบวางบิล (สรุป/รายละเอียด) แยกตามวันที่", {
            font: { bold: true, size: 14 },
            alignment: "center",
        });

        const rangeText = `วันที่: ${toThaiDate(fromMoment)} ถึง ${toThaiDate(toMoment)}, รหัสลูกค้า : ทุกรหัสลูกค้า`;
        addFullWidthRow(rangeText, {
            font: { size: 12 },
            alignment: "center",
        });

        addFullWidthRow("");

        let headerRowIndex = worksheet.lastRow ? worksheet.lastRow.number + 1 : 1;
        const headerRow = worksheet.addRow([
            "วันที่",
            "เลขที่ใบวางบิล",
            "ครบกำหนด",
            "รหัส-ชื่อ ลูกค้า",
            "รวมเงิน",
            "หมายเหตุ",
        ]);
        // use actual header row number for freezing and later reference
        headerRowIndex = headerRow.number;
        headerRow.height = 20;
        headerRow.font = { bold: true, color: { argb: "FFFFFFFF" } };
        headerRow.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FF6D6D6D" },
        };
        headerRow.alignment = { vertical: "middle", horizontal: "center" };
        headerRow.eachCell((cell) => {
            cell.border = {
                top: { style: "thin", color: { argb: "FF000000" } },
                left: { style: "thin", color: { argb: "FF000000" } },
                bottom: { style: "thin", color: { argb: "FF000000" } },
                right: { style: "thin", color: { argb: "FF000000" } },
            };
            cell.alignment = { vertical: "middle", horizontal: "center" };
        });

        worksheet.getColumn(1).width = 14;
        worksheet.getColumn(2).width = 22;
        worksheet.getColumn(3).width = 14;
        worksheet.getColumn(4).width = 40;
        worksheet.getColumn(5).width = 18;
        worksheet.getColumn(6).width = 28;

        worksheet.getColumn(5).numFmt = "#,##0.00";

        let currentRowIndex = worksheet.lastRow.number + 1;
        let totalAmount = 0;

        rowsSorted.forEach((item) => {
            const amount = sanitizeAmount(item?.BL_Net_Total ?? item?.Pay_Total);
            totalAmount += amount;

            const docDateValue = item?.Doc_Date ?? item?.DocDate ?? item?.Doc_Date_Display;
            const dueDateValue = item?.Doc_Due_Date ?? item?.Doc_DueDate ?? item?.Doc_Due_Date_Display;
            const docDate = toThaiDate(docDateValue);
            const dueDate = toThaiDate(dueDateValue);
            const customerCode = item?.AR_Code ? String(item.AR_Code).trim() : "";
            const customerName = item?.AR_Name ? String(item.AR_Name).trim() : "";
            const customerDisplay = [customerCode, customerName].filter((part) => part).join(" - ") || "-";

            const dataRow = worksheet.getRow(currentRowIndex);
            dataRow.values = [
                docDate,
                item?.Doc_No || "-",
                dueDate,
                customerDisplay,
                amount,
                combineRemark(item),
            ];
            dataRow.eachCell((cell, colNumber) => {
                cell.border = {
                    top: { style: "thin", color: { argb: "FF000000" } },
                    left: { style: "thin", color: { argb: "FF000000" } },
                    bottom: { style: "thin", color: { argb: "FF000000" } },
                    right: { style: "thin", color: { argb: "FF000000" } },
                };
                if (colNumber === 5) {
                    cell.alignment = { horizontal: "right", vertical: "middle" };
                    cell.numFmt = "#,##0.00";
                } else if (colNumber === 4 || colNumber === 6) {
                    cell.alignment = { horizontal: "left", vertical: "middle" };
                } else {
                    cell.alignment = { horizontal: "center", vertical: "middle" };
                }
            });
            currentRowIndex += 1;
        });

        const summaryRowIndex = currentRowIndex;
        worksheet.mergeCells(`A${summaryRowIndex}:E${summaryRowIndex}`);
        const summaryTextCell = worksheet.getCell(`A${summaryRowIndex}`);
        summaryTextCell.value = `รวมจำนวนบิลทั้งสิ้น ${rowsSorted.length.toLocaleString()} รายการ`;
        summaryTextCell.font = { bold: true };
        summaryTextCell.alignment = { horizontal: "right", vertical: "middle" };
        summaryTextCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFECEFF1" },
        };
        summaryTextCell.border = {
            top: { style: "thin", color: { argb: "FF000000" } },
            left: { style: "thin", color: { argb: "FF000000" } },
            bottom: { style: "thin", color: { argb: "FF000000" } },
            right: { style: "thin", color: { argb: "FF000000" } },
        };

        const summaryAmountCell = worksheet.getCell(`F${summaryRowIndex}`);
        summaryAmountCell.value = Number(totalAmount.toFixed(2));
        summaryAmountCell.font = { bold: true };
        summaryAmountCell.alignment = { horizontal: "right", vertical: "middle" };
        summaryAmountCell.numFmt = "#,##0.00";
        summaryAmountCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFECEFF1" },
        };
        summaryAmountCell.border = {
            top: { style: "thin", color: { argb: "FF000000" } },
            left: { style: "thin", color: { argb: "FF000000" } },
            bottom: { style: "thin", color: { argb: "FF000000" } },
            right: { style: "thin", color: { argb: "FF000000" } },
        };


        currentRowIndex = summaryRowIndex + 1;
        nextRowIndex = worksheet.lastRow ? worksheet.lastRow.number + 1 : currentRowIndex;
        addFullWidthRow("");
        const printedAt = moment();
        const printedDateText = `${printedAt.format("DD/MM")}/${printedAt.year() + 543}`;
        const printedTimeText = printedAt.format("HH:mm:ss");
        addFullWidthRow(`วันที่พิมพ์ : ${printedDateText} เวลา : ${printedTimeText}`, {
            font: { size: 12 },
            alignment: "left",
        });
        addFullWidthRow(`ผู้พิมพ์ : ${writtenBy}`, {
            font: { size: 12 },
            alignment: "left",
        });

        worksheet.views = [{ state: "frozen", ySplit: headerRowIndex }];

        const fileRangeLabel = `${fromMoment ? fromMoment.format("YYYYMMDD") : "ทั้งหมด"}-${toMoment ? toMoment.format("YYYYMMDD") : "ทั้งหมด"}`;
        const buffer = await workbook.xlsx.writeBuffer();
        const sanitizedLabel = fileNamePrefix.replace(/[\u0000-\u001f\\/:*?"<>|]/g, "_");
        saveAs(new Blob([buffer]), `${sanitizedLabel}_${fileRangeLabel}.xlsx`);
    } catch (error) {
        console.error("Error exporting bill report:", error);
        getAlert("FAILED", "ไม่สามารถ Export ข้อมูลได้");
    }
}

export async function ExportMonthlyExpenseSummary(data, year, month, monthLabel = "") {
    if (!Array.isArray(data) || data.length === 0) {
        return getAlert("FAILED", "ไม่มีข้อมูลสำหรับพิมพ์รายงาน");
    }

    try {
        // Convert display year to พ.ศ. (Thai Buddhist Era). If input already looks like พ.ศ. (> 2400), keep it.
        const baseYear = Number(year) || new Date().getFullYear();
        const thaiYear = baseYear > 2400 ? baseYear : baseYear + 543;

        const workbook = new ExcelJS.Workbook();
        const sheetName = `สรุปค่าใช้จ่าย_${month || ''}-${thaiYear}`;
        const worksheet = workbook.addWorksheet(sheetName);

        // Header title
        const title = `รายงานสรุปค่าใช้จ่ายประจำเดือน ${monthLabel || month}/${thaiYear}`;
        worksheet.mergeCells("A1:C1");
        worksheet.getCell("A1").value = title;
        worksheet.getCell("A1").font = { size: 14, bold: true };
        worksheet.getCell("A1").alignment = { horizontal: "center" };

        // Table headers
        worksheet.getRow(2).values = ["กลุ่มสินค้า", "รายละเอียด", "รวมจ่ายสุทธิ"];
        worksheet.columns = [
            { key: "Group_Name", width: 25 },
            { key: "Item_Name", width: 40 },
            { key: "Total_Amount", width: 18 },
        ];
        worksheet.getRow(2).eachCell((cell) => {
            cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFEF6C00" },
            };
            cell.alignment = { vertical: "middle", horizontal: "center" };
        });

        // Data rows
        let grandTotal = 0;
        data.forEach((row) => {
            const amount = Number(row.Total_Amount) || 0;
            grandTotal += amount;
            const excelRow = worksheet.addRow([
                row.Group_Name || "-",
                row.Item_Name || "-",
                formatCurrency(amount),
            ]);
            excelRow.getCell(3).alignment = { horizontal: "right" };
        });

        // Total row
        const totalRowNumber = worksheet.lastRow.number + 1;
        worksheet.mergeCells(`A${totalRowNumber}:B${totalRowNumber}`);
        const totalCell = worksheet.getCell(`A${totalRowNumber}`);
        totalCell.value = "รวมค่าใช้จ่ายทั้งสิ้น";
        totalCell.font = { bold: true };
        totalCell.alignment = { horizontal: "right" };
        const totalValueCell = worksheet.getCell(`C${totalRowNumber}`);
        totalValueCell.value = formatCurrency(grandTotal);
        totalValueCell.font = { bold: true };
        totalValueCell.alignment = { horizontal: "right" };

        // Borders for all rows
        worksheet.eachRow((row, rowNumber) => {
            if (rowNumber >= 2) {
                row.eachCell((cell) => {
                    cell.border = {
                        top: { style: "thin", color: { argb: "FF000000" } },
                        left: { style: "thin", color: { argb: "FF000000" } },
                        bottom: { style: "thin", color: { argb: "FF000000" } },
                        right: { style: "thin", color: { argb: "FF000000" } },
                    };
                });
            }
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const fileName = `รายงานสรุปค่าใช้จ่าย_${month || ''}-${thaiYear}.xlsx`;
        saveAs(new Blob([buffer]), fileName);
    } catch (error) {
        console.error("Error exporting monthly expense summary:", error);
        getAlert("FAILED", "ไม่สามารถ Export ข้อมูลได้");
    }
}

const ILLEGAL_SHEET_CHAR_REGEX = /[:\\/?*\[\]]/g;
const DEFAULT_SHEET_NAME = "Report";
const DEFAULT_FILE_NAME = "report.xlsx";

function sanitiseSheetName(name) {
    if (!name || typeof name !== "string") {
        return DEFAULT_SHEET_NAME;
    }
    const trimmed = name.replace(ILLEGAL_SHEET_CHAR_REGEX, " ").trim();
    if (!trimmed) {
        return DEFAULT_SHEET_NAME;
    }
    return trimmed.length > 31 ? trimmed.slice(0, 31) : trimmed;
}

function sanitiseFileName(name) {
    if (!name || typeof name !== "string") {
        return DEFAULT_FILE_NAME;
    }
    const trimmed = name.trim();
    if (!trimmed) {
        return DEFAULT_FILE_NAME;
    }
    return trimmed.replace(/[<>:\"/\\|?*\x00-\x1F]/g, "_");
}

function extractTableMatrix(tableElement) {
    const rows = [];
    const headerRowIndexes = new Set();
    const tableRows = Array.from(tableElement.querySelectorAll("tr"));

    tableRows.forEach((rowElement, rowIndex) => {
        if (!rows[rowIndex]) rows[rowIndex] = [];
        let columnPointer = 0;
        const cells = Array.from(rowElement.children);

        cells.forEach((cell) => {
            const isHeaderCell = cell.tagName.toLowerCase() === "th" || !!cell.closest("thead");
            const colSpan = Number(cell.colSpan) > 0 ? Number(cell.colSpan) : 1;
            const rowSpan = Number(cell.rowSpan) > 0 ? Number(cell.rowSpan) : 1;
            const cellText = (cell.textContent || "").replace(/\s+/g, " ").trim();

            while (rows[rowIndex][columnPointer] !== undefined) {
                columnPointer += 1;
            }

            for (let r = 0; r < rowSpan; r += 1) {
                const targetRowIndex = rowIndex + r;
                if (!rows[targetRowIndex]) rows[targetRowIndex] = [];

                for (let c = 0; c < colSpan; c += 1) {
                    const targetColIndex = columnPointer + c;
                    if (r === 0 && c === 0) {
                        rows[targetRowIndex][targetColIndex] = cellText;
                    } else {
                        rows[targetRowIndex][targetColIndex] = "";
                    }
                }

                if (isHeaderCell) {
                    headerRowIndexes.add(targetRowIndex);
                }
            }

            columnPointer += colSpan;
        });
    });

    const maxColumns = rows.reduce((max, currentRow) => {
        if (!currentRow) return max;
        return Math.max(max, currentRow.length);
    }, 0);

    const normalisedRows = rows.map((row = []) => {
        if (row.length < maxColumns) {
            const padded = [...row];
            for (let i = row.length; i < maxColumns; i += 1) {
                padded[i] = "";
            }
            return padded;
        }
        return row;
    });

    return {
        rows: normalisedRows,
        headerRowIndexes: Array.from(headerRowIndexes).sort((a, b) => a - b),
    };
}

export async function exportHtmlTableToExcel(tableElement, options = {}) {
    if (!tableElement || typeof tableElement !== "object") {
        return getAlert("FAILED", "ไม่พบตารางข้อมูลสำหรับ Export");
    }

    const { rows, headerRowIndexes } = extractTableMatrix(tableElement);

    const hasDataRows = rows.some((row, index) => {
        if (headerRowIndexes.includes(index)) return false;
        return row.some((cell) => cell !== "");
    });

    if (!hasDataRows) {
        return getAlert("FAILED", "ไม่มีข้อมูลสำหรับ Export");
    }

    try {
        const workbook = new ExcelJS.Workbook();
        const sheetName = sanitiseSheetName(
            options.sheetName ||
            tableElement.getAttribute("data-export-sheet") ||
            DEFAULT_SHEET_NAME
        );
        const worksheet = workbook.addWorksheet(sheetName);

        const columnCount = rows[0]?.length || rows.reduce((max, currentRow = []) => Math.max(max, currentRow.length), 0) || 1;
        const headerLines = Array.isArray(options.headerLines)
            ? options.headerLines
                .map((line) => (typeof line === "string" ? line.trim() : ""))
                .filter((line) => line.length > 0)
            : [];

        if (headerLines.length > 0) {
            headerLines.forEach((line, index) => {
                const headerRow = worksheet.addRow([line]);
                if (columnCount > 1) {
                    worksheet.mergeCells(headerRow.number, 1, headerRow.number, columnCount);
                }
                headerRow.height = 20;
                headerRow.getCell(1).font = {
                    bold: true,
                    size: index === 0 ? 16 : 12,
                };
                headerRow.getCell(1).alignment = {
                    horizontal: "center",
                    vertical: "middle",
                };
            });

            // เพิ่มบรรทัดว่างเพื่อเว้นระยะระหว่างหัวข้อกับตาราง
            worksheet.addRow([]);
        }

        rows.forEach((rowValues, rowIndex) => {
            const excelRow = worksheet.addRow(rowValues);
            if (headerRowIndexes.includes(rowIndex)) {
                excelRow.eachCell((cell) => {
                    cell.font = { bold: true };
                    cell.alignment = { vertical: "middle", horizontal: "center" };
                    cell.fill = {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: "FFE0E0E0" },
                    };
                });
            }
        });

        worksheet.columns.forEach((column) => {
            let maxLength = 8;
            column.eachCell({ includeEmpty: true }, (cell) => {
                const value = cell.value == null ? "" : cell.value.toString();
                if (value.length > maxLength) {
                    maxLength = value.length;
                }
            });
            column.width = Math.min(maxLength + 2, 50);
        });

        const fileName = sanitiseFileName(
            options.fileName ||
            tableElement.getAttribute("data-export-file") ||
            `${sheetName}.xlsx`
        );

        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), fileName.endsWith(".xlsx") ? fileName : `${fileName}.xlsx`);
    } catch (error) {
        console.error("Error exporting table:", error);
        getAlert("FAILED", "ไม่สามารถ Export ข้อมูลได้");
    }
}
